import { request } from "@/utils/request";

export const speciesWithNumericalValue = () => {
  return request.get("/species/speciesWithNumericalValue");
};

export const tfCountsByFamily = () => {
  return request.get("/species/tfCountsByFamily");
};

export const tfCountsBySpecies = (species) => {
  return request.get(`/species/tfCountsBySpecies?species=${species}`);
};

export const numericalValueByFamily = () => {
  return request.get("/species/numericalValueByFamily");
};
